// data/languages/swahili/categories/famille.ts

import { CategoryData } from '../../../../types/types';

export const famille: CategoryData = {
  'Mama': { translation: 'Mère', translationEn: 'Mother', audio: 'Sw-mama', illustration: '👩🏿' },
  'Baba': { translation: 'Père', translationEn: 'Father', audio: 'Sw-baba', illustration: '👨🏿' },
  'Kaka mkubwa': { translation: 'Frère aîné', translationEn: 'Older brother', illustration: '👦🏿' },
  'Kaka mdogo / Dada mdogo': { translation: 'Frère cadet / Sœur cadette', translationEn: 'Younger brother / Younger sister', illustration: '👦🏿👧🏿' },
  'Dada mkubwa': { translation: 'Sœur aînée', translationEn: 'Older sister', illustration: '👧🏿' },
  'Babu': { translation: 'Grand-père', translationEn: 'Grandfather', illustration: '👴🏿' },
  'Bibi': { translation: 'Grand-mère', translationEn: 'Grandmother', illustration: '👵🏿' },
  'Mjomba': { translation: 'Oncle maternel', translationEn: 'Maternal uncle', audio: 'Sw-mjomba', illustration: '🧔🏿' },
  'Amu': { translation: 'Oncle paternel', translationEn: 'Paternal uncle', illustration: '🧔🏿' },
  'Shangazi': { translation: 'Tante paternelle', translationEn: 'Paternal aunt', audio: 'Sw-shangazi', illustration: '👩🏿' },
  'Mama mdogo': { translation: 'Tante maternelle', translationEn: 'Maternal aunt', illustration: '👩🏿' },
  'Binamu': { translation: 'Cousin(e)', translationEn: 'Cousin', audio: 'Sw-binamu', illustration: '🧑🏿' },
  'Mke': { translation: 'Épouse', translationEn: 'Wife', illustration: '👰🏿' },
  'Mume': { translation: 'Mari', translationEn: 'Husband', illustration: '🤵🏿' },
  'Mwanandoa': { translation: 'Époux/Épouse', translationEn: 'Spouse', illustration: '💑🏿' },
  'Mtoto': { translation: 'Enfant', translationEn: 'Child', audio: 'Sw-mtoto', illustration: '👶🏿' },
  'Mtoto wa kiume': { translation: 'Fils', translationEn: 'Son', illustration: '👦🏿' },
  'Mtoto wa kike': { translation: 'Fille', translationEn: 'Daughter', illustration: '👧🏿' },
  'Mjukuu': { translation: 'Petit-fils/Petite-fille', translationEn: 'Grandson/Granddaughter', illustration: '👶🏿' },
  'Shemeji': { translation: 'Beau-frère / Belle-sœur', translationEn: 'Brother-in-law / Sister-in-law', illustration: '🤵🏿👰🏿' },
};

export default famille;

export {};
